import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../add-banner/addbanner.scss";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import Loading from "../../components/loading/Loading";

function Editbanner() {
  const [loading, setLoading] = useState();
  const { id } = useParams();
  const [name, setName] = useState("");
  const [note, setNote] = useState("");
  const [image, setImage] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();
  const [title, setTitle] = useState();
  const sizeImage = 1000000;

  const getData = async () => {
    const result = await axios.get(`https://mobile.amospa.com/banners/${id}`);
    setName(result.data.data[0].name);
    setNote(result.data.data[0].note);
    setImage(result.data.data[0].image);
    handlesetAdd(result.data.data[0]);
  };

  const [add, setAdd] = useState({
    name: "",
    note: "",
    image: "",
  });

  const handlesetAdd = (data) => {
    setAdd({
      name: data.name,
      note: data.note,
      image: data.image,
    });
  };

  // Handle Patch Data Banner
  const updateBanner = async () => {
    const update = new FormData();
    if (image.size > sizeImage) {
      setTitle("Image size is too Big, Maximum size 1MB");
      setModalShow(true);
    } else if (add.name !== name || add.note !== note || add.image !== image) {
      update.append("name", name);
      update.append("note", note);
      update.append("image", image);
      setLoading(true);
      await axios.put(`https://mobile.amospa.com/banners/${id}`, update);
      setLoading(false);
      setTitle("Update Banner Success");
      setModalShow(true);
    } else {
      setTitle("No Data Changes");
      setModalShow(true);
    }
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
    navigate("/homepage/setting/banner");
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="wrapper-add-banner">
                <div className="header-add-banner">
                  <h5 className="m-0">Edit Banner</h5>
                </div>
                <div className="form-add-banner">
                  <div className="wrapper-data">
                    <label>Name</label>
                    <input
                      type="text"
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>Notes</label>
                    <input
                      type="text"
                      onChange={(e) => setNote(e.target.value)}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>
                      Image (Max 1MB)
                      <span className="text-danger ms-2">
                        {image && image.size > sizeImage
                          ? "Image size is too Big"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="File"
                      onChange={(e) => setImage(e.target.files[0])}
                    />
                  </div>
                  <button
                    className=" text-white"
                    onClick={() => updateBanner()}
                  >
                    Save Update Banner
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={title}
        nextButton={
          title !== "Image size is too Big, Maximum size 1MB"
            ? handleNext
            : () => setModalShow(false)
        }
      />
    </div>
  );
}

export default Editbanner;
